import { render, staticRenderFns } from "./header_mobil.vue?vue&type=template&id=9bbcf64c"
import script from "./header_mobil.vue?vue&type=script&lang=js"
export * from "./header_mobil.vue?vue&type=script&lang=js"
import style0 from "./header_mobil.vue?vue&type=style&index=0&id=9bbcf64c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports